import { type RefObject, useEffect, useRef, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { AutoSaveStatus } from 'hooks/useDebouncedFieldAutosave';
import type { SaveResult } from 'hooks/updateResult';

export type AutosaveTimeoutsRef = RefObject<{
  [key: string]: ReturnType<typeof setTimeout>;
}>;

export interface UseAutosaveStatusReturn {
  autoStatus: Record<string, AutoSaveStatus>;
  setAutoStatus: Dispatch<SetStateAction<Record<string, AutoSaveStatus>>>;
  autosaveTimeouts: AutosaveTimeoutsRef;
}

export interface EditorAutosaveDeps {
  autosaveEditAsync: SaveResult;
  autosaveTimeouts: AutosaveTimeoutsRef;
  setAutoStatus: Dispatch<SetStateAction<Record<string, AutoSaveStatus>>>;
  setHasUserEdits: Dispatch<SetStateAction<boolean>>;
}

export function useAutosaveStatus(resultId?: string | number): UseAutosaveStatusReturn {
  const [autoStatus, setAutoStatus] = useState<Record<string, AutoSaveStatus>>({});
  const autosaveTimeouts = useRef<{ [key: string]: ReturnType<typeof setTimeout> }>({});

  useEffect(() => {
    setAutoStatus({});
    Object.values(autosaveTimeouts.current).forEach((t) => clearTimeout(t));
    autosaveTimeouts.current = {};
  }, [resultId]);

  useEffect(() => {
    return () => {
      Object.values(autosaveTimeouts.current).forEach((t) => clearTimeout(t));
    };
  }, []);

  return { autoStatus, setAutoStatus, autosaveTimeouts };
}
